import { Heading } from "@/components/ui/heading";
import { RegularPageLayout } from "@/components/layout/PageLayouts";
export default function PrivacyPage() {
	const contactEmail = import.meta.env.VITE_CONTACT_EMAIL || "info@textformatter.pro";

	return (
		<RegularPageLayout width="6xl" paddingY="8">
			<section className="rounded-2xl border border-slate-200 bg-white p-6 sm:p-8">
				<Heading>Privacy Policy</Heading>
				<div className="mt-6 space-y-4 text-sm leading-7 text-slate-700 sm:text-base">
					<p>
						Text Formatter collects only the information necessary to provide and improve the
						service.
					</p>
					<Heading as="h2">Data We Collect</Heading>
					<p>We may collect:</p>
					<ul className="list-disc space-y-2 pl-6">
						<li>Account information such as email address and login credentials</li>
						<li>API usage and request metadata</li>
						<li>Billing-related information processed through third-party payment providers</li>
						<li>
							Technical information such as IP address, browser type, and device information for
							security and abuse prevention
						</li>
					</ul>
					<p>We do not sell personal data.</p>
					<Heading as="h2">Payments</Heading>
					<p>
						Payments are processed by third-party payment providers such as Stripe. We do not store
						full payment card details on our servers.
					</p>
					<Heading as="h2">Cookies and Authentication</Heading>
					<p>
						We may use cookies or similar technologies to maintain login sessions, improve security,
						and provide core application functionality.
					</p>
					<Heading as="h2">Security</Heading>
					<p>
						We use reasonable security measures to protect account access, API keys, and service
						infrastructure. However, no online service can guarantee absolute security.
					</p>
					<Heading as="h2">Third-Party Services</Heading>
					<p>
						We may use third-party providers for infrastructure, analytics, email delivery,
						authentication, and payment processing.
					</p>
					<Heading as="h2">Your Rights</Heading>
					<p>
						You may contact us to request account-related support or deletion requests where
						applicable.
					</p>
					<Heading as="h2">Changes</Heading>
					<p>
						This policy may be updated as the product evolves or legal requirements change. The
						latest version will always be available on this page.
					</p>
					<Heading as="h2">Contact</Heading>
					<p>
						<a
							className="font-medium text-ink underline underline-offset-2"
							href={`mailto:${contactEmail}`}
						>
							{contactEmail}
						</a>
					</p>
				</div>
			</section>
		</RegularPageLayout>
	);
}
